import { AbstractError } from '@/domain/errors/abstract-error.js';

export class ContractValidationError extends AbstractError {
    public readonly code = 500;

    constructor(
        message: string,
        public readonly issues: ReadonlyArray<{ path: PropertyKey[]; message: string }> = []
    ) {
        super(message);
    }
}
